import { Component, OnInit, ViewChild,ElementRef, AfterViewInit  } from '@angular/core';
import { PeticionesService } from '../servicios/httpservice';
import { DataDBService } from '../servicios/data-db.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FiltrosService } from '../servicios/filtros.service';
import {LocalStorageService} from 'ngx-webstorage';
import { MatPaginator, PageEvent,MatPaginatorIntl } from '@angular/material/paginator';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-search-prospectacion',
  templateUrl: './search-prospectacion.component.html',
  styleUrls: ['./search-prospectacion.component.css']
})
export class SearchProspectacionComponent implements OnInit {
  public strTipo:string = ""
  public jsonIa:any;
  public arrayTipos:any = [
    {"label": "Contabilidad", "value": "accounting"},
    {"label": "Aeropuerto", "value": "airport"},
    {"label": "Parque de diversiones", "value": "amusement_park"},
    {"label": "Acuario", "value": "aquarium"},
    {"label": "Galería de arte", "value": "art_gallery"},
    {"label": "Cajero automático", "value": "atm"},
    {"label": "Panadería", "value": "bakery"},
    {"label": "Banco", "value": "bank"},
    {"label": "Bar", "value": "bar"},
    {"label": "Salón de belleza", "value": "beauty_salon"},
    {"label": "Tienda de bicicletas", "value": "bicycle_store"},
    {"label": "Librería", "value": "book_store"},
    {"label": "Boliche", "value": "bowling_alley"},
    {"label": "Estación de autobuses", "value": "bus_station"},
    {"label": "Cafetería", "value": "cafe"},
    {"label": "Campamento", "value": "campground"},
    {"label": "Concesionaria de autos", "value": "car_dealer"},
    {"label": "Renta de autos", "value": "car_rental"},
    {"label": "Taller mecánico", "value": "car_repair"},
    {"label": "Autolavado", "value": "car_wash"},
    {"label": "Casino", "value": "casino"},
    {"label": "Cementerio", "value": "cemetery"},
    {"label": "Iglesia", "value": "church"},
    {"label": "Ayuntamiento", "value": "city_hall"},
    {"label": "Tienda de ropa", "value": "clothing_store"},
    {"label": "Tienda de conveniencia", "value": "convenience_store"},
    {"label": "Juzgado", "value": "courthouse"},
    {"label": "Dentista", "value": "dentist"},
    {"label": "Tienda departamental", "value": "department_store"},
    {"label": "Doctor", "value": "doctor"},
    {"label": "Farmacia", "value": "drugstore"},
    {"label": "Electricista", "value": "electrician"},
    {"label": "Tienda de electrónica", "value": "electronics_store"},
    {"label": "Embajada", "value": "embassy"},
    {"label": "Estación de bomberos", "value": "fire_station"},
    {"label": "Florería", "value": "florist"},
    {"label": "Funeraria", "value": "funeral_home"},
    {"label": "Mueblería", "value": "furniture_store"},
    {"label": "Gasolinera", "value": "gas_station"},
    {"label": "Gimnasio", "value": "gym"},
    {"label": "Peluquería", "value": "hair_care"},
    {"label": "Ferretería", "value": "hardware_store"},
    {"label": "Templo hindú", "value": "hindu_temple"},
    {"label": "Tienda del hogar", "value": "home_goods_store"},
    {"label": "Hospital", "value": "hospital"},
    {"label": "Agencia de seguros", "value": "insurance_agency"},
    {"label": "Joyería", "value": "jewelry_store"},
    {"label": "Lavandería", "value": "laundry"},
    {"label": "Abogado", "value": "lawyer"},
    {"label": "Biblioteca", "value": "library"},
    {"label": "Estación de tren ligero", "value": "light_rail_station"},
    {"label": "Licorería", "value": "liquor_store"},
    {"label": "Oficina gubernamental local", "value": "local_government_office"},
    {"label": "Cerrajería", "value": "locksmith"},
    {"label": "Hospedaje", "value": "lodging"},
    {"label": "Entrega de comida", "value": "meal_delivery"},
    {"label": "Comida para llevar", "value": "meal_takeaway"},
    {"label": "Mezquita", "value": "mosque"},
    {"label": "Renta de películas", "value": "movie_rental"},
    {"label": "Cine", "value": "movie_theater"},
    {"label": "Mudanzas", "value": "moving_company"},
    {"label": "Museo", "value": "museum"},
    {"label": "Club nocturno", "value": "night_club"},
    {"label": "Pintor", "value": "painter"},
    {"label": "Parque", "value": "park"},
    {"label": "Estacionamiento", "value": "parking"},
    {"label": "Tienda de mascotas", "value": "pet_store"},
    {"label": "Farmacia", "value": "pharmacy"},
    {"label": "Fisioterapeuta", "value": "physiotherapist"},
    {"label": "Plomero", "value": "plumber"},
    {"label": "Policía", "value": "police"},
    {"label": "Oficina postal", "value": "post_office"},
    {"label": "Escuela primaria", "value": "primary_school"},
    {"label": "Inmobiliaria", "value": "real_estate_agency"},
    {"label": "Restaurante", "value": "restaurant"},
    {"label": "Contratista de techos", "value": "roofing_contractor"},
    {"label": "Parque de casas rodantes", "value": "rv_park"},
    {"label": "Escuela", "value": "school"},
    {"label": "Escuela secundaria", "value": "secondary_school"},
    {"label": "Zapatería", "value": "shoe_store"},
    {"label": "Centro comercial", "value": "shopping_mall"},
    {"label": "Spa", "value": "spa"},
    {"label": "Estadio", "value": "stadium"},
    {"label": "Almacenamiento", "value": "storage"},
    {"label": "Tienda", "value": "store"},
    {"label": "Estación de metro", "value": "subway_station"},
    {"label": "Supermercado", "value": "supermarket"},
    {"label": "Sinagoga", "value": "synagogue"},
    {"label": "Sitio de taxis", "value": "taxi_stand"},
    {"label": "Atracción turística", "value": "tourist_attraction"},
    {"label": "Estación de tren", "value": "train_station"},
    {"label": "Estación de tránsito", "value": "transit_station"},
    {"label": "Agencia de viajes", "value": "travel_agency"},
    {"label": "Universidad", "value": "university"},
    {"label": "Veterinaria", "value": "veterinary_care"},
    {"label": "Zoológico", "value": "zoo"}
  ]
  public cards = [
    {"label": "Contabilidad", "value": "accounting"},
    {"label": "Aeropuerto", "value": "airport"},
    {"label": "Parque de diversiones", "value": "amusement_park"},
    {"label": "Acuario", "value": "aquarium"},
    {"label": "Galería de arte", "value": "art_gallery"},
    {"label": "Cajero automático", "value": "atm"},
    {"label": "Panadería", "value": "bakery"}];
  public strKeyword:string = "";
  public arrayEstados:any = [];
  public arrayAccesos: any = [];
  public boolSelect:boolean = false;
  public urlWeb :string= ""
  public strPregunta:string = ""
  public arrayMunicipios:any = [];
  public arrayBdMunicipios:any = [];
  public arrayComparar:any = [];
  public strConexion:string="";
  public objComentario:any;
  public arrayFiltrados:any = [];
  public boolSpinner:boolean =false
  public boolSpinnerModal:boolean =false
  public objEstado:any = {};
  public objMunicipio:any = {};
  public objBdEstado:any = {};
  public objBdMunicipio:any = {};
  public arrayKm:any = [];
  public strPageToken:string="";
  public strNombreWeb:string=""
  public strRespuestaiA:any;
  public strLatitud:any;
  public strLongitud:any;
  public boolUbcAct:boolean=false;
  public arrayAgentes:any = [];
  public strAgente:string = "";
  public searchAgent:string="";
  public arrayLugares:any = [];
  @ViewChild('paginadorExistentes') paginadorExistentes!: MatPaginator;
  @ViewChild('paginadornuevos') paginadornuevos!: MatPaginator;
  @ViewChild('btnCerarModal') btnCerarModal!: ElementRef;
  
  public arrayDetails:any = [];
  public arrayProspectosBd:any=[];
  public strComentario:string =""
  public strBdTipo:string = "";
  public strBDKeyword:string = "";
  public pageSizeNuevos = 60;
  public currentPageNuevos = 0;
  public arrayPaginadoNuevos: any[] = [];
  public pageSizeBD = 60;
  public currentPageBD = 0;
  public arrayPaginadobd: any[] = [];
  public arrayEstadosBd:any = [];

  public intKm:number = 50000
  constructor(private _filtroServ: FiltrosService,private paginatorIntl: MatPaginatorIntl,private localSt:LocalStorageService, private router: Router, private _httpService:PeticionesService,private indexedDBService: DataDBService) { 
    this.arrayKm = [] 
    for(let i = 1;i<51; i++){
      this.arrayKm.push({strNombre:i+" km",intKm:i*1000})
    }
    this.arrayTipos.sort((a, b) => a.label.localeCompare(b.label));
    this. customizeItemsPerPageLabel();
  
  }
  ngOnInit(): void {
    this._httpService.setMostrarMenu(true);
    // this.arrayAccesos = this.localSt.retrieve('arrayAccesos') ? this.localSt.retrieve('arrayAccesos') : [];
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
    if (this.arrayAccesos.length > 0) {
       
        this.strConexion = this.localSt.retrieve('strConexion');
        this.updatePageDataNuevos();
        this.updatePageDataBd();
        this.fnGetEstados().then(()=>{
          this.objEstado = this.arrayEstados.find(o => o.estado == "Guanajuato")
          this.arrayEstadosBd = this.arrayEstados;
          this.objBdEstado = this.objEstado;
          this.fnGetMunicipios().then(()=>{
            this.objMunicipio = this.arrayMunicipios.find(o => o.municipio == "León")
          });
          this.fnGetMunicipiosBD().then( () => {
            this.objBdMunicipio = this.arrayBdMunicipios.find(o => o.municipio == "León")
          });
          
        })
  
     } else {
      this.router.navigate(['/login']);
     }
    });
  }

  ngAfterViewInit() {
    this._filtroServ.array_Agentes_$.subscribe((nuevoValor) => {
      this.arrayAgentes = nuevoValor;
    });

    this.paginadorExistentes.page.subscribe((event) => this.onPageChangeBd(event));
    this.paginadornuevos.page.subscribe((event) => this.onPageChangeNuevos(event));
  }

  customizeItemsPerPageLabel() {
    this.paginatorIntl.itemsPerPageLabel = 'Registros por página';
  }

  onPageChangeNuevos(event: PageEvent) {
    this.pageSizeNuevos = event.pageSize;
    this.currentPageNuevos = event.pageIndex;
    this.updatePageDataNuevos();
  }
  
  updatePageDataNuevos() {
    this.boolSpinner = true;
    const start = this.currentPageNuevos * this.pageSizeNuevos;
    const end = start + this.pageSizeNuevos;
    this.arrayPaginadoNuevos = this.arrayDetails.slice(start, end);
    console.log(this.arrayPaginadoNuevos);
    this.boolSpinner = false;

  }
  
  onPageChangeBd(event: PageEvent) {
    this.pageSizeBD = event.pageSize;
    this.currentPageBD = event.pageIndex;
    this.updatePageDataBd();
  }
  
  updatePageDataBd() {
    const start = this.currentPageBD * this.pageSizeBD;
    const end = start + this.pageSizeBD;
    this.arrayPaginadobd = this.arrayProspectosBd.slice(start, end);
  }

  fnGetEstados(): Promise<void>{
    return new Promise((resolve, reject) => {
    this.arrayEstados = []
    this.arrayMunicipios = []
    let totalRequests = 5;
    let completedRequests = 0;

    for(let i= 1 ;i<6;i++){
      this._httpService.getDatosDesdeJson(i+"").subscribe(
        res => {
          this.arrayEstados.push(...res)
          completedRequests++;
          if (completedRequests === totalRequests) {
            this.arrayEstados.sort((a, b) => a.estado.localeCompare(b.estado));
            resolve();
          }
        },
        err => {
          reject(err); 
        });    
    }});
    
  }

  fnGetMunicipios(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.arrayMunicipios = [];
      if (this.objEstado && this.objEstado.municipios) {
        this.arrayMunicipios = this.objEstado.municipios;
        this.arrayMunicipios.sort((a, b) => a.municipio.localeCompare(b.municipio));
        resolve(); 
      } else {
        reject("No hay municipios disponibles.");
      }
    });
  }

  fnGetMunicipiosBD(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.arrayBdMunicipios = [];
      if (this.objBdEstado && this.objBdEstado.municipios) {
        this.arrayBdMunicipios = this.objBdEstado.municipios;
        this.arrayBdMunicipios.sort((a, b) => a.municipio.localeCompare(b.municipio));
        resolve();
      } else {
        reject("No hay municipios disponibles."); 
      }
    });
  }

  onBdEstadoChange() {
    this.fnGetMunicipiosBD()
      .then(() => {
        console.log("Municipios cargados correctamente.");
      })
      .catch(err => {
        console.warn("Error al cargar municipios:", err);
      });
  }
/*  fnBuscarUbicaciones(pageToken:string=""){
  if(this.strKeyword != ""){
    this.strTipo = ""
  }
  let objDatos: {lat: number; lng: number; radio: number;keyword?: string; tipo?: string,nextPageToken:string;}=
  {lat:this.boolUbcAct==true?this.strLatitud:this.objMunicipio.latitud, lng:this.boolUbcAct==true?this.strLongitud:this.objMunicipio.longitud, 
    radio:this.intKm, keyword:this.strKeyword, tipo:this.strTipo, nextPageToken : pageToken }
  this.arrayDetails = []
  this._httpService.getbuscarLugares(objDatos).subscribe((response: any) => {

    
    let  nuevosLugares = response.results.filter((nuevo: any) => {
      return !this.arrayLugares.some(existente => existente.place_id === nuevo.place_id);
    });
  
    this.arrayLugares = [...this.arrayLugares, ...nuevosLugares];

    this.strPageToken = response.next_page_token
  });
 } */
fnBuscarUbicaciones(pageToken: string = ""): Promise<void> {
  return new Promise((resolve, reject) => {
    if (this.strKeyword != "") {
      this.strTipo = "";
    }

    let objDatos = {
      lat: this.boolUbcAct ? this.strLatitud : this.objMunicipio.latitud,
      lng: this.boolUbcAct ? this.strLongitud : this.objMunicipio.longitud,
      radio: this.intKm,
      keyword: this.strKeyword,
      tipo: this.strTipo,
      nextPageToken: pageToken
    };

    this._httpService.getbuscarLugares(objDatos).subscribe(
      (response: any) => {
        let nuevosLugares = response.results.filter((nuevo: any) => {
          return !this.arrayLugares.some(existente => existente.place_id === nuevo.place_id);
        });
        this.arrayLugares = [...this.arrayLugares, ...nuevosLugares];
        this.strPageToken = response.next_page_token;
        resolve();
      },
      (error: any) => {
        console.error('Error en fnBuscarUbicaciones', error);
        reject(error);
      }
    );
  });
}

 /* fnBuscarLug(){
  this.boolSpinner = true;
  this.arrayLugares = [];
  this.strPageToken = "";
  this.arrayDetails = [];
  this.arrayPaginadoNuevos = []
  let timer = 0;
  for(let i = 0;i<3;i++){
    console.log("Ingresa for "+ i)
    setTimeout(() => {
      this.fnBuscarUbicaciones(i==0?null:this.strPageToken)
    }, timer);
    timer = timer + 2000
  }
  setTimeout(() => {
    console.log(this.arrayLugares)
    let timer2 = 0
    this.arrayLugares.forEach(obj => {
      setTimeout(() => {
        this.fnGetDetails(obj.place_id)
      }, timer2);
      timer2 += 100
    });
    setTimeout(() => {
      console.log(this.arrayDetails);
      this.arrayDetails.forEach(det => {
        det.selectCard = false;
      });
      this.fnCompararLugares()
    
    }, timer+1000);
   
  }, timer+1000);
 }
 */

async fnBuscarLug(){
  try{
    this.startSpinner();
    this.arrayLugares = [];
    this.arrayDetails = [];
    this.arrayPaginadoNuevos = [];
    this.strPageToken = "";

    for (let i = 0; i < 3; i++){
      console.log("Buscando ubicacion pagina "+i);
      await this.fnBuscarUbicaciones(i == 0 ? null:this.strPageToken);
      await this.sleep(2000);
    }

    await this.fnObtenerDetallesDeTodos();
    await this.fnCompararLugares();
  } catch(error){
    console.log("Error en fnBuscarLug:",error)
  }finally{
    this.stopSpinner();
  }
}


async fnObtenerDetallesDeTodos(){
  let peticiones = this.arrayLugares.map(obj => this._httpService.getPlaceDetails(obj.place_id))
  try {
      let resultados = await forkJoin(peticiones).toPromise();
      this.arrayDetails = resultados.map((res:any) => res.result);
  }catch(error){
    console.log("Error obtenido detalles:", error)
  }
}





 fnGetDetails(idPlace:string){
 this._httpService.getPlaceDetails(idPlace).subscribe((result: any) => {
    this.arrayDetails.push(result.result);
    
    /* this.arrayLugares.forEach(obj => {
      obj.
      setTimeout(() => {
        this.boolSpinner = false
      }, timer);
      timer += 300
    }); */
  });
 }

 fnInfoPlace(obj:any){
    this.urlWeb = obj.website
    this.strNombreWeb = obj.name
    this.strPregunta = ""
    this.strRespuestaiA = []
    console.log(this.urlWeb);
    this.fnModalInicioIa();
 }

 fnia(){
  const prompt = ` 
    Te proporcionaré una URL de una empresa prospecto: ${this.urlWeb} y una pregunta específica que ha hecho un vendedor sobre esa empresa.
    ⚠️ Es muy importante que:
    - SOLO utilices la información visible dentro del sitio web ${this.urlWeb} para responder.
    - NO uses resultados de otras webs, redes sociales o empresas con nombres similares.
    - Respondas en español, con redacción clara, concisa y profesional.

    ➡️ PÁGINA WEB: ${this.urlWeb}  
    ➡️ PREGUNTA DEL VENDEDOR: ${this.strPregunta}  

    🔍 TAREA:
    1. Analiza el contenido de la web proporcionada.
    2. Extrae únicamente la información relevante que responda con precisión a la pregunta hecha por el vendedor.
    3. Si la información **no está disponible directamente en el sitio web**, responde:  
    **"La información solicitada no está disponible directamente en el sitio web proporcionado."**

    ✅ FORMATO DE RESPUESTA:
    {
      "respuesta": "Tu respuesta concreta aquí, basada únicamente en la web.",
      "fuente": "Contenido visible en la web ${this.urlWeb}"
    }`;

     this._httpService.sendIA(prompt).subscribe(
      res => {
        this.strRespuestaiA = res.candidates[0].content.parts[1].text.replace(/```json/g, '').replace(/```/g, '').trim();
        try {
          this.jsonIa = JSON.parse(this.jsonIa);
          
          console.log('JSON convertido correctamente:', this.jsonIa);
        } catch (e) {
          console.error('Error al convertir JSON:', e);
        }
        console.log(this.strRespuestaiA);
        this.boolSpinner = false
      },error =>{
        this.boolSpinner = false
      }) 
 }
 fnModalInicioIa(){
  this.boolSpinnerModal = true
  const prompt = `
Tarea 1.0: Analiza únicamente la web ${this.urlWeb} y extrae la información en el siguiente formato JSON, con claves claras y valores fáciles de acceder. No utilices información de otras empresas con nombres similares. Limítate a lo que veas en esa web, en español y en México.

{
  "tarea_1": {
    "informacion_encontrada": "Resumen del contenido general visible en la web ${this.urlWeb}.",
    "descripcion_general": "Descripción concisa sobre productos o servicios ofrecidos.",
    "contacto": {
      "telefonos": ["teléfono 1", "teléfono 2"],
      "correos": ["correo1@ejemplo.com", "correo2@ejemplo.com"]
    }
  },
  "tarea_2": {
    "empleados_en_webs_relacionadas": [
      {
        "nombre": "Nombre del empleado",
        "correo": "correo@ejemplo.com",
        "telefono": "tel"
      }
    ]
  },
  "tarea_3": {
    "empleados_en_web_principal": [
      {
        "nombre": "Nombre del empleado",
        "correo": "correo@ejemplo.com",
        "telefono": "tel"
      }
    ]
  },
  "tarea_4": {
    "empleados_en_directorios": [
      {
        "nombre": "Nombre del empleado",
        "correo": "correo@ejemplo.com",
        "telefono": "tel"
      }
    ]
  }
}

IMPORTANTE:
- Si algún dato no está disponible, devuélvelo como una cadena vacía o null.
- No inventes información.
- Usa este formato JSON EXACTAMENTE como se indica, no lo regreses como array regresalo como objeto así como se te esta mostrando el formato.
`;
 /*  const prompt = `Tarea 1.0: Busca información actualizada sobre la web ${this.urlWeb} con el objetivo de enriquecer un CRM. Es muy importante que tu búsqueda solo se base en esta web  ${this.urlWeb}  que te estoy especificando primero, ya que puede haber otras empresas que se llamen igual, para ello, solo te vas a limitar a la búsqueda en español y solo en México. Extrae y organiza la información en formato JSON de la siguiente manera: 1.1 Información encontrada en la web  ${this.urlWeb} . 1.2 Descripción general (Características clave de la página web sobre los servicios o productos que ofrece. Sé conciso y enfócate en lo que esta empresa ofrece directamente en su web  ${this.urlWeb}  que te mencioné y no en otras.). 1.3 Contacto (Información de contacto encontrada directamente en la web  ${this.urlWeb}  .). 1.4 Teléfonos: (Lista de números de teléfono). 1.5 correos_electronicos: (Lista de correos electrónicos). Después de hacerlo solo en la web ${this.urlWeb} que te dí, ahora ejecuta esta otra Tarea 2.0: (Busca en webs relacionadas información sobre personas que trabajen en esta empresa pero igual solo en español y solo en méxico, incluyendo sus nombres, correos electrónicos o teléfonos. Tarea 3.0: (Busca en toda la web  ${this.urlWeb} informacion de empleados de esta empresa.) Tarea 4.0: (Busca en directorios online de empresas, información de empleados de esta empresa.) FORMATO: Realiza la búsqueda y organiza la información en el formato JSON especificado. `; */

    this._httpService.sendIA(prompt).subscribe(
      (res:any) => {
        console.log(res)
        this.jsonIa  = res.candidates[0].content.parts[0].text.replace(/```json/g, '').replace(/```/g, '').trim();
        try {
          this.strRespuestaiA =  JSON.parse(this.jsonIa);
        //  this.strRespuestaiA = Object.entries(this.strRespuestaiA);
        } catch (e) {
          this.boolSpinnerModal = false;
        }
        console.log(this.strRespuestaiA)
        this.boolSpinnerModal = false;
        },error =>{
         this.boolSpinnerModal = false;
      })
 }


 fnGetColonias(){
  this._httpService.getColonias('12','050').subscribe((result: any) => {
     console.log(result)
     /* this.arrayLugares.forEach(obj => {
       obj.
       setTimeout(() => {
         this.boolSpinner = false
       }, timer);
       timer += 300
     }); */
   });
  }

  fnGetGuardarEstablecimientos(){
    let xml = []
    let fecha = new Date()
    this.arrayDetails.forEach(loc => {
      if(loc.selectCard== true){
        

        let typesArray: string[] = loc.types;
        let tipos: string = typesArray.join(' | ');
        let Horarios:string [] = loc && loc.opening_hours && loc.opening_hours.weekday_text?loc.opening_hours.weekday_text:""
        let strHorarios = Horarios.join(' | ')
        xml.push({
          strIDestablecimiento:loc.place_id,
          strNombre:loc.name,
          strDireccion:loc.vicinity,
          strTelefonoLocal:loc.formatted_phone_number,
          strTelefonoInter:loc.international_phone_number?loc.international_phone_number:"",
          strurlMaps:loc.url,
          strSitioWeb:loc.website,
          strHorarios:strHorarios,
          strLatitud:loc.geometry.location.lat,
          strLongitud:loc.geometry.location.lng,

          /* strFechaInsert:fecha,
          strFechaUltimoCambio:fecha, */
          NOMBRE_SUCURSAL:loc.icon,
          RAZON_SOCIAL:tipos,
        });
      }
    });
    let objEnviar ={
      strConexion:this.strConexion,
      strAccion:"insertEstablecimientos",
      strEstado:this.objEstado.estado,
      strDelegacion:this.objMunicipio.municipio,
      xmlSucursales:xml
    }

    this._httpService.mostrarCotizaciones(objEnviar, 'sp_modVentas_Leads').subscribe(
      result => {
        console.log(result);
      if(result && result[0] && result[0].code == 200){
        Swal.fire("Guardado",result[0].strMensaje,"success")
        this.fnGetProspectosSave();
        this.fnEliminarAgregagos(objEnviar.xmlSucursales);
      }else{
        Swal.fire("Error",result[0].strMensaje,"error")
      }
    }, error => {
          var error = <any>error;
          console.log(error);
        }
      );
  }
  fnGetProspectosSave(){
    let objEnviar ={
      strConexion:this.strConexion,
      strAccion:"getEstablecimientos",
      strDelegacion:this.objBdMunicipio.municipio,
      strEstado:this.objBdEstado.estado
    }
    this._httpService.mostrarCotizaciones(objEnviar, 'sp_modVentas_Leads').subscribe(
      result => {
        let rest = result
        if (rest.length>0){
          console.log(rest)
          this.arrayProspectosBd = rest
          this.updatePageDataBd()
        }else{
          Swal.fire(
            "Sin resultados",
            "No se encontraron registros disponibles para el municipio seleccionado.",
            "info"
          );
        }
     
    }, error => {
          var error = <any>error;
          console.log(error);
        }
      );
  }

 fnSeleccionarTodos(){
  if(this.arrayDetails.length>0){
    this.arrayDetails.forEach(det => {
      det.selectCard = true;
      });
      this.boolSelect = true
  }else{
    this.boolSelect = false
  }
 }
 fnQuitarTodos(){
  if(this.arrayDetails.length>0){
    this.arrayDetails.forEach(det => {
      det.selectCard = false;
      });
      this.boolSelect = false
  }else{
    this.boolSelect = true
  }
 
 }
 fnGuardarProsp(){
  let arrayGuardar = [];
  this.arrayDetails.forEach(det => {
    if( det.selectCard == true){
      arrayGuardar.push(det)
    }
  });

    console.log(arrayGuardar)
 }

  obtenerUbicacion() {

    if(this.boolUbcAct == true){
      this.boolUbcAct = false;
      this.strLatitud = 0;
      this.strLongitud = 0;
    }else{
      this.boolUbcAct = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.strLatitud = position.coords.latitude;
            this.strLongitud = position.coords.longitude;
            Swal.fire("DATOS","LATITUD: "+this.strLatitud+"\n LONGITUD: "+this.strLongitud,"info")
            console.log(`Latitud: ${this.strLatitud}, Longitud: ${this.strLongitud}`);
            this.objEstado = [];
            this.objMunicipio = [];
          },
          (error) => {
            console.error('Error al obtener la ubicación:', error.message);
          }
        );
      } else {
        console.error('La geolocalización no está soportada por este navegador.');
      }
    }
  }
  onTipoChange(event: any) {
    const nuevoValor = event.value;
    console.log("Tipo seleccionado:", nuevoValor);
    if(nuevoValor != "" ){
      this.strKeyword = "";
    }
  }

  onKeywordChange(valor: string) {

    if(valor != "" ){
      this.strTipo = "";
    }
    // Puedes hacer una búsqueda, autocompletar, etc.
  }
  fnComentarioLugar(obj:any){
    this.objComentario = obj;
    this.strComentario = obj.strComentario;
  }

  fnSaveComentario(){
    let objEnviar ={
      strConexion:this.strConexion,
      strAccion:"updateEstablecimiento",
      strComentario:this.strComentario,
      strIDestablecimiento:this.objComentario.strIDestablecimiento
    
    }
    this._httpService.mostrarCotizaciones(objEnviar, 'sp_modVentas_Leads').subscribe(
      result => {
        if(result && result[0] && result[0].code == 200){
          Swal.fire("Guardado",result[0].strMensaje,"success")
          this.fnGetProspectosSave();
          this.btnCerarModal.nativeElement.click()
        }else{
          Swal.fire("Error",result[0].strMensaje,"error")
        }
    }, error => {
          var error = <any>error;
          console.log(error);
        }
      );
  }

/*   fnCompararLugares(){
    this.boolSpinner = true
    this.arrayComparar = [];
    let objEnviar ={
      strConexion:this.strConexion,
      strAccion:"getEstablecimientos",
      strDelegacion:this.objMunicipio.municipio,
      strEstado:this.objEstado.estado
    }
    this._httpService.mostrarCotizaciones(objEnviar, 'sp_modVentas_Leads').subscribe(
      result => {
        let rest = result
       
        if (rest.length>0){
          let idsEstablecimientos = rest.map((r: any) => r.strIDestablecimiento);
          this.arrayDetails = this.arrayDetails.filter((item: any) => {
            return !idsEstablecimientos.includes(item.place_id);
          });
          this.updatePageDataNuevos()
          console.log('Filtrado:', this.arrayDetails);
          this.boolSpinner = false
        }else{
          this.updatePageDataNuevos()
          console.log('Filtrado:', this.arrayDetails);
          this.boolSpinner = false
        }
     
    }, error => {
          var error = <any>error;
          console.log(error);
          this.boolSpinner = false
        }
      );
  } */

  fnCompararLugares(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.arrayComparar = [];
      let objEnviar = {
        strConexion: this.strConexion,
        strAccion: "getEstablecimientos",
        strDelegacion: this.objMunicipio.municipio,
        strEstado: this.objEstado.estado
      };

      this._httpService.mostrarCotizaciones(objEnviar, 'sp_modVentas_Leads').subscribe(
        (result: any) => {
          if (result.length > 0) {
            let idsEstablecimientos = result.map((r: any) => r.strIDestablecimiento);
            this.arrayDetails = this.arrayDetails.filter((item: any) => !idsEstablecimientos.includes(item.place_id));
          }
          this.updatePageDataNuevos();
          resolve();
        }, (error: any) => {
          console.error('Error en fnCompararLugares', error);
          reject(error);
        }
      );
    });
  }

  startSpinner() { 
    this.boolSpinner = true; 
  }

  stopSpinner() { 
    this.boolSpinner = false; 
  }

  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  fnEliminarAgregagos(arrayEliminar:any){
    this.arrayDetails = this.arrayDetails.filter(objDetail => {
      return !arrayEliminar.some(objEliminar => objEliminar.strIDestablecimiento === objDetail.place_id);
    });
    this.updatePageDataNuevos()
  }
}
